var render = function render(){var _vm=this,_c=_vm._self._c;return _c('servicos',{attrs:{"permitirAprovar":_vm.$temAcessoView('GESCON-UFI-APROV-00'),"permitirReprovar":_vm.$temAcessoView('GESCON-UFI-APROV-00'),"permiteDetalhar":_vm.$temAcessoView('GESCON-UFI-APROV-00'),"rotaDetalhar":"Gescon_Financeiro_Servicos_Detalhar","rotaListagem":"Gescon_Financeiro_Servicos_Listagem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }